import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import { NotAuthorized } from "_shared/_errors/_views/not-authorized";
import { RootState, useAttorneyHubDispatch } from "_shared/_stores/redux-store";
import Loader from "_shared/_views/loading/loader";
import { getSessionPermissions, populateSessionPermissions } from "permissions/_stores/permissions-redux-slice";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLoaderData, useNavigate } from "react-router";
import { useSession } from "users/__session/session-context";
import ContactsTab from "users/networking/_views/contacts-tab";
import CoworkersTab from "users/networking/_views/coworkers-tab";
import GroupsTab from "users/networking/_views/groups-tab";
import { PageTab } from "users/networking/_views/network-page-tabs";
import PendingTab from "users/networking/_views/pending-tab";

const LoaderContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
}));

export default function Network() {
  const routeParams = useLoaderData();
  const activeTab = routeParams?.pageTab ? (routeParams.pageTab as PageTab) : PageTab.Contacts;

  const navigate = useNavigate();
  const dispatch = useAttorneyHubDispatch();
  const session = useSession();
  const sessionPermissions = useSelector(getSessionPermissions);
  const sessionPermissionsLoading = useSelector((state: RootState) => state.permissions.session.loading);
  const sessionPermissionsError = useSelector((state: RootState) => state.permissions.session.error);

  useEffect(() => {
    if (!sessionPermissions && !sessionPermissionsError && !sessionPermissionsLoading) {
      dispatch(populateSessionPermissions({ session }));
    }
  }, [dispatch, session, sessionPermissions, sessionPermissionsError, sessionPermissionsLoading]);

  // Handle URL changes
  useEffect(() => {
    if (!session.user?.legalEntityId) return;

    if (!routeParams.pageTab) {
      navigate(`/network/${PageTab.Contacts}`);
    }
  }, [navigate, routeParams, session.user?.legalEntityId]);

  if (!sessionPermissions)
    return (
      <LoaderContainer>
        <Loader fontSize="20px" />
      </LoaderContainer>
    );
  if (!sessionPermissions.includesAccessToNetwork) return <NotAuthorized />;

  switch (activeTab) {
    case PageTab.Contacts:
      return <ContactsTab />;
    case PageTab.Coworkers:
      return <CoworkersTab />;
    case PageTab.Pending:
      return <PendingTab />;
    case PageTab.Groups:
      return <GroupsTab />;
    default:
      return <ContactsTab />;
  }
}
